var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInboundSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "22px",
    viewBox: "0 0 24 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3837472,17.8162047 L15.2143999,14.6468575 C14.3407978,15.2157147 13.2945068,15.5407759 12.1669506,15.4798269 C9.75946564,15.3680871 7.69735827,13.4888267 7.37229701,11.1016581 C7.15471137,9.49243541 7.71765996,7.87592857 8.88777201,6.74997169 C10.0578841,5.62401481 11.6948396,5.12363281 13.2945068,5.40292786 C15.2753489,5.73814729 16.9209715,7.28218827 17.3577726,9.242714 C17.692992,10.725806 17.3679308,12.1073164 16.6467011,13.2043981 L19.8262065,16.3839036 C20.2223749,16.780072 20.2223749,17.4200363 19.8262065,17.8162047 C19.4300381,18.2123731 18.7799156,18.2123731 18.3837472,17.8162047 Z M15.4581959,10.4109029 C15.4581959,8.73480578 14.0868437,7.36345359 12.4107465,7.36345359 C10.7346494,7.36345359 9.36329722,8.73480578 9.36329722,10.4109029 C9.36329722,12.087 10.7346494,13.4583522 12.4107465,13.4583522 C14.0868437,13.4583522 15.4581959,12.087 15.4581959,10.4109029 Z",
    id: "Shape",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.366272,18.75 C11.4145078,18.75 7.9868616,18.75 2.0833333,18.75 C0.9327401,18.75 0,17.81726 0,16.666667 L0,2.083333 C0,0.93274 0.9327401,0 2.0833333,0 L7.2916667,0 L9.375,3.125 L18.75,3.125 C19.9005932,3.125 20.8333333,4.05774 20.8333333,5.208333 C20.8333333,8.82353135 20.8333333,10.5349301 20.8333333,12.3425293",
    id: "Shape",
    stroke: "currentColor",
    strokeWidth: 2.08333333,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboundSearch);
export default __webpack_public_path__ + "static/media/inboundSearch.5406a0f8f9b80d500ae6fd3391ee013e.svg";
export { ForwardRef as ReactComponent };